// ** busPark
const initialState = {
  busPark: false
}

const busPark = (state = initialState, action) => {
  switch (action.type) {
    case "BUS_PARK":
      return { ...state, busPark: action.val }
    default:
      return state
  }
}

export default busPark
